/** The node the manage app is mounted in: the shadow root of the `<pentacode-app>` running it, else the document. */
export function getAppRoot(): ParentNode {
    for (const host of document.querySelectorAll("pentacode-app")) {
        if (host.shadowRoot?.querySelector("ptc-app")) {
            return host.shadowRoot;
        }
    }
    return document;
}
